import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col, ButtonToolbar, Button, Input} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import delay from '../../core/redux/delay'
import {connectForm, selectField, controlledField} from '../../core/redux/form'
import Card from '../../core/components/Card'
import RadioToggle from '../../core/components/RadioToggle'
import LoaderButton from '../../core/components/LoaderButton'
import DayPicker from '../../core/components/DayPicker'
import TimePicker from '../../core/components/TimePicker'
import AgencySelectInput from '../../company/components/AgencySelectInput'
import {OPEN_TICKET_CLAIM_CMD_UPDATED, sendOpenTicketClaimCmd, queryTicketClaimStream, updateOpenTicketClaimCmd} from '../actions'
import {OpenTicketClaimCmd} from '../models'
import i18n from '../i18n'
import style from './OpenTicketClaimCard.less'

class OpenTicketClaimCard extends Component {
    static propTypes = {
    }

    componentWillMount() {
        const {dispatch, cmd} = this.props

        const commandType = cmd && cmd.commandType || 'OpenTicketClaimOnExternalTicket'
        dispatch(updateOpenTicketClaimCmd({commandType}))
    }

    _sendCmd() {
        const {dispatch} = this.props

        return dispatch(sendOpenTicketClaimCmd()).then((action) => {
            const ticketClaimId = action.events.find((e) => e.eventType == 'TicketClaimOpened' || e.eventType == 'TicketClaimOpenedOnExternalTicket').aggregateUid
            return dispatch(push('/claims/' + ticketClaimId))
        }).then(() => {
            return dispatch(delay(queryTicketClaimStream()))
        })
    }

    render() {
        const {dispatch, form, cmd, reference, authenticated, ...others} = this.props

        const header = (
            <h5>{i18n.openTicketClaim}</h5>
        )

        const urgencyLevelLabel = (urgencyLevel) => (
            <span>
                <span>{urgencyLevel.label}</span>
                <small>{urgencyLevel.info}</small>
            </span>
        )

        return (
            <Card
                header={header}
                {...others}>
                <div className={style.defaultContent}>
                    <form>
                        {form.ticketReference && (
                            <Input
                                type='text'
                                placeholder={i18n.ticketReference + ' *'}
                                {...form.ticketReference()} />
                        )}
                        {form.externalClientName && (
                            <Input
                                type='text'
                                placeholder={i18n.externalClientName}
                                {...form.externalClientName()} />
                        )}
                        {form.externalPatrimonyReference && (
                            <Input
                                type='text'
                                placeholder={i18n.externalPatrimonyReference}
                                {...form.externalPatrimonyReference()} />
                        )}
                        {form.agencyUid && (
                            <AgencySelectInput
                                user={authenticated}
                                name='agency'
                                {...selectField(form.agencyUid())}>
                                <option value=''>{i18n.selectAgency} *</option>
                            </AgencySelectInput>
                        )}
                        <Input
                            type='textarea'
                            rows={4}
                            placeholder={i18n.description + ' *'}
                            {...controlledField(form.description())} />
                    </form>
                    <Row>
                        <Col sm={6}>
                            {reference.urgencyLevel.length > 0 && (
                                <div>
                                    <h5>{i18n.urgencyLevel}</h5>
                                    <RadioToggle
                                        {...form.urgencyLevelUid()}>
                                        {reference.urgencyLevel.map((urgencyLevel) => (
                                            <Input
                                                key={urgencyLevel.uid}
                                                type='radio'
                                                label={urgencyLevelLabel(urgencyLevel)}
                                                value={urgencyLevel.uid} />
                                        ))}
                                    </RadioToggle>
                                </div>
                            )}
                        </Col>
                        <Col sm={6}>
                            {form.externalCallDate && (
                                <div>
                                    <h5>{i18n.externalCallDate}</h5>
                                    <div className={style.externaCallDateTimePicker}>
                                        <div className={style.container}>
                                            <DayPicker
                                                {...form.externalCallDate()} />
                                            <TimePicker typing
                                                {...form.externalCallDate()} />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.validate}
                        </LoaderButton>
                    </ButtonToolbar>
                </div>
            </Card>
        )
    }
}

OpenTicketClaimCard = connectForm({
    target: 'cmd',
    schema: OpenTicketClaimCmd.selectSchema,
    action: OPEN_TICKET_CLAIM_CMD_UPDATED
})(OpenTicketClaimCard)

OpenTicketClaimCard = connect((state) => ({
    cmd: state.claim.openTicketClaimCmd,
    reference: state.reference.ticketClaimRef,
    authenticated: state.user.authenticated
}))(OpenTicketClaimCard)

export default OpenTicketClaimCard


// WEBPACK FOOTER //
// ./lib/claim/components/OpenTicketClaimCard.js